import { axiosInstance } from './config/instance'
import { CONSOLE_API_URL, SERVER } from './config/url'

const SETTINGS_URL = `${SERVER}/${CONSOLE_API_URL}`
const ENTITY = 'settings'

export const settings = Object.freeze({
  async fetchOpenApi() {
    const response = await axiosInstance.get(`${SETTINGS_URL}/${ENTITY}/o`)
    return response.data
  },
  async updateOpenApi(data) {
    const response = await axiosInstance.put(`${SETTINGS_URL}/openapi/${ENTITY}/1`, data)
    return response.data
  },
  async fetchSwitch() {
    const response = await axiosInstance.get(`${SETTINGS_URL}/${ENTITY}/s`)
    return response.data
  },
  async updateSwitch(data) {
    const response = await axiosInstance.put(`${SETTINGS_URL}/switch/${ENTITY}/0`, data)
    return response.data
  },
})
